import React, { type ComponentProps } from 'react'
import { ListItem } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { type ListItemProps } from '@fs/zion-tree-types/zion-ui'
import ConclusionBody from './ConclusionBody'
import { getConclusionDisplayLabel } from '../helpers/helpers'

type Props = Pick<
  ComponentProps<typeof ConclusionBody>,
  'conclusion' | 'person' | 'truncate' | 'hideDate' | 'hidePlace' | 'hideWarnings' | 'showStandard'
> &
  Partial<ListItemProps>

export default function ListItemConclusion({
  conclusion,
  truncate,
  hideWarnings,
  hideDate,
  hidePlace,
  person,
  showStandard,
  ...props
}: Props): JSX.Element {
  const [t] = useTranslation()
  return (
    <ListItem
      primaryText={getConclusionDisplayLabel(t, conclusion.type)}
      secondaryText={
        <ConclusionBody
          conclusion={conclusion}
          person={person}
          truncate={truncate}
          hideDate={hideDate}
          hidePlace={hidePlace}
          hideWarnings={hideWarnings}
          showStandard={showStandard}
        />
      }
      {...props}
    />
  )
}
